export enum FeatureToggle {
  webhookConfiguration = 'rt_webhook_configuration',
  webhookItemUpdateEvents = 'rt_connect_item_status_update_callbacks',
}
